import React from 'react';

function LandingSectionHeader({ eyebrow, title, description, className = '', align = 'center' }) {
  return <div className={`landing-section-head text-${align} ${className}`.trim()}>
    {eyebrow && <span className="lead text-muted">{eyebrow}</span>}
    <h2 className="display-4 my-3">{title}</h2>
    {description && <h3 className="lead text-muted my-2">{description}</h3>}
  </div>;
}

export default LandingSectionHeader;
